import { pyrotchBaseUrl, axiosBaseQuery } from "../axios/AxiosInstance";
import { createApi } from "@reduxjs/toolkit/query/react";
import { AnnouncementsRequest } from "../../models/Announcements";
import { AnnouncementsResponse } from "../../models/Announcements";

export const AnnouncementsApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "announcementsApi",
  tagTypes: ["Announcements"],

  endpoints(build) {
    return {
      createAnnouncements: build.mutation<any, AnnouncementsRequest>({
        query: (AnnouncementsData) => ({
          url: `announcements`,
          method: "POST",
          data: AnnouncementsData,
        }),
        invalidatesTags: ["Announcements"],
      }),
      updateAnnouncements: build.mutation<any, { AnnouncementId: Number, AnnouncementsData: AnnouncementsRequest }>({
        query: ({ AnnouncementId, AnnouncementsData }) => ({
          url: `announcements/${AnnouncementId}`,
          method: "PUT",
          data: AnnouncementsData,
        }),
        invalidatesTags: ["Announcements"],
      }),
      getAnnouncements: build.query<AnnouncementsResponse, { page: number; size: number }>({
        query: ({ page, size }) => ({
          url: `announcements?page=${page}&size=${size}`,
          method: "GET",
        }),
        providesTags: ["Announcements"],
      }),
      deleteAnnouncements: build.mutation<void, number>({
        query: (AnnouncementId) => {
          return {
            url: `announcements/${AnnouncementId}`,
            method: "DELETE",
          };
        },
        invalidatesTags: ["Announcements"],
      }),
      getUnReadAnnouncement: build.query({
        query: () => ({
          url: `announcements/unread`,
          method: "GET",
        })
      }),
      markAsReadAnnouncement: build.mutation<any, { announcementId: any }>({
        query: ({ announcementId }) => ({
          url: `announcements/read/${announcementId}`,
          method: "POST",
          data: announcementId,
        })
      }),
    };
  },
});

export const {
  useCreateAnnouncementsMutation,
  useUpdateAnnouncementsMutation,
  useDeleteAnnouncementsMutation,
  useLazyGetAnnouncementsQuery,
  useLazyGetUnReadAnnouncementQuery,
  useMarkAsReadAnnouncementMutation
} = AnnouncementsApi;
